import { environment } from '../../../../environments/environment';

export class TranslationConstants {
  public static readonly TRANSLATIONS = `${environment.instance}_translations`;
  public static readonly LIST_OF_TRANSLATED_MODULES = `${environment.instance}_modules_translated`;
}
